import { withViewerScope, type ViewerScopedQueryOptions } from "@/lib/viewer-scoped-query";
import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";
import type { OfferCondition } from "@garimpa/lib/offerConditions";

export function getDealOfferFormatSummariesQueryOptions(
  input: {
    condition?: OfferCondition;
    workId: string;
    currency: string;
  },
  options: ViewerScopedQueryOptions = {},
) {
  return withViewerScope(
    orpc.deals.getOfferFormatSummaries.queryOptions({
      input,
      staleTime: QUERY_STALE_TIMES.dealOffers,
    }),
    options.viewerId,
  );
}
